<p-dialog [(visible)]="display" [styleClass]="'notifyModal'" [appendTo]="'body'"
          [header]="'NOTIFY_COMPONENT.MODAL_TITLE' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true" [closeOnEscape]="false"
          (onHide)="displayChange.emit(false);this.resetComponent()">
  <div class="grid">
    <div class="col-12" *ngIf="showRejectReason">
      <h3>{{'GROUND_COMPONENT.REASON_TITLE' | translate}}</h3>
      <textarea pInputTextarea [(ngModel)]="rejectReason" rows="5"></textarea>
    </div>
    <div class="col-12">
      <div class="title-1">{{'NOTIFY_COMPONENT.INPUT_TITLE' | translate}}</div>
      <div class="title-2">{{'NOTIFY_COMPONENT.INPUT_TITLE2' | translate}}</div>
    </div>
    <div class="col-12" #hhhhh>
      <p-chips [(ngModel)]="emailList" (onAdd)="testItem($event)" [allowDuplicate]="false" [max]="10">
        <ng-template let-item pTemplate="item" class="">
          <i class="fa fa-envelope-o"></i> {{item}}
        </ng-template>
      </p-chips>
    </div>
    <div class="col-12">
      <span class="invalid-email" *ngIf="invalidInput">
        {{errorMessageLabel}} : {{invalidInput}}
      </span>
      <span class="invalid-email" *ngIf="emptyList">
        {{errorEmptyListLabel}}.
      </span>
    </div>
    <div class="col-12" *ngIf="showRejectReason">
      <button pButton type="button" [icon]="'fa fa-times'"
              [label]="'SIGNATURE.AND.VALIDATION_COMPONENT.DECLINE_BUTTON_LABEL' | translate"
              (click)="emitRejection()"
              class="p-button-danger"></button>
    </div>
    <div class="col-12" *ngIf="!showRejectReason">
      <button pButton type="button" [icon]="'fa fa-check'"
              [label]="'SIGNATURE.AND.VALIDATION_COMPONENT.ACCEPT_BUTTON_LABEL' | translate"
              (click)="emitAcceptation()"
              class="p-button-success"></button>
    </div>
  </div>
</p-dialog>
